import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Counts a number up from 0 to `target` once the returned ref scrolls into
// view. Returns [value, ref] — render `value` wherever the static number was.
export function useCountUp(target, { duration = 1.8, decimals = 0 } = {}) {
  const [value, setValue] = useState(0);
  const ref = useRef(null);
  const numericTarget = Number(target) || 0;

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setValue(numericTarget);
      return undefined;
    }

    const counter = { val: 0 };
    const trigger = ScrollTrigger.create({
      trigger: el,
      start: "top 88%",
      once: true,
      onEnter: () => {
        gsap.to(counter, {
          val: numericTarget,
          duration,
          ease: "power2.out",
          onUpdate: () => setValue(Number(counter.val.toFixed(decimals))),
        });
      },
    });

    return () => trigger.kill();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numericTarget, duration, decimals]);

  return [value, ref];
}

export default useCountUp;
